import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from "../..";

/**
 * Content of section item.
 *
 * @param {*} props
 */
import { jsx as _jsx } from "react/jsx-runtime";
var SectionItemContent = function SectionItemContent(props) {
  var children = props.children,
    content = props.content,
    compact = props.compact;
  if (compact) {
    if (children) {
      return /*#__PURE__*/_jsx(Grid.Row, {
        style: {
          paddingTop: 0
        },
        children: /*#__PURE__*/_jsx(Grid.Column, {
          width: 16,
          children: children
        })
      });
    }
    return /*#__PURE__*/_jsx(Grid.Row, {
      style: {
        paddingTop: 0
      },
      children: /*#__PURE__*/_jsx(Grid.Column, {
        width: 16,
        children: content
      })
    });
  }
  if (children) {
    return /*#__PURE__*/_jsx(Grid.Row, {
      children: /*#__PURE__*/_jsx(Grid.Column, {
        width: 16,
        children: children
      })
    });
  }
  return /*#__PURE__*/_jsx(Grid.Row, {
    children: /*#__PURE__*/_jsx(Grid.Column, {
      width: 16,
      children: content
    })
  });
};

/** Proptypes */
SectionItemContent.handledProps = ["children", "compact", "content"];
SectionItemContent.propTypes = {
  /** */
  children: PropTypes.node,
  /** */
  content: PropTypes.node,
  /** A SectionItemContent may take up only as much space as is necessary. */
  compact: PropTypes.bool
};
export default SectionItemContent;